import { useTranslation } from 'react-i18next';
import { AppUpdate } from '@capawesome/capacitor-app-update';

import style from './style.module.css';

export const UpdateAvailable = () => {
    const { t } = useTranslation();

    const handleUpdate = async () => {
        try {
            await AppUpdate.openAppStore({ appId: '6449964869' });
        } catch {
            window.open('https://apps.apple.com/app/id6449964869', '_blank');
        }
    };

    return (
        <div className={style.root}>
            <div className={style.title}>
                {t(`C'est l'heure de la mise à jour !`)}
            </div>
            <div className={style.subTitle}>
                {t(`Votre App Stimul'in a été enrichie.\nPour profiter des nouvelles fonctionnalités et optimisations, nous vous invitons à la mettre à jour dès maintenant.`)}
            </div>
            <button className={style.cta} onClick={handleUpdate}>
                {t('Mettre à jour')}
            </button>
        </div>
    );
};